/**
 * Sizing Table Custom Element
 * Handles unit toggling between IN and CM using data attributes
 */
if (!customElements.get('sizing-table')) {
  class SizingTable extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this._currentUnit = 'in';
      this._init();
    }

    _init() {
      const unitBtns = this.querySelectorAll('.unit-btn');
      if (unitBtns.length === 0) return;

      unitBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const unit = btn.getAttribute('data-unit');
          if (unit) this._setUnit(unit);
        });
      });

      // Initial state sync
      const activeBtn = this.querySelector('.unit-btn.is-active') || this.querySelector('.unit-btn[data-unit="in"]');
      if (activeBtn) {
        this._setUnit(activeBtn.getAttribute('data-unit'));
      }
    }

    _setUnit(unit) {
      if (this._currentUnit === unit && this.querySelectorAll('.unit-btn.is-active').length > 0) return;
      this._currentUnit = unit;

      // Update button active states
      this.querySelectorAll('.unit-btn').forEach(btn => {
        btn.classList.toggle('is-active', btn.getAttribute('data-unit') === unit);
      });

      // Update all value cells that have data-in/data-cm
      this.querySelectorAll('td[data-in], td[data-cm]').forEach(cell => {
        const value = cell.getAttribute(`data-${unit}`);
        if (value !== null) {
          cell.textContent = value;
        }
      });
    }
  }

  customElements.define('sizing-table', SizingTable);
}
